import type React from 'react'
import type { JSX, Ref } from 'react'
import type { IconNames } from 'atoms/Icon'
import type { ITextBoxProps } from 'atoms/TextBox'

import { Icon, IconSizes } from 'atoms/Icon'
import { TextBox, TextBoxColors, TextBoxTypes } from 'atoms/TextBox'
import { FIXED_INDENTS } from 'vars/index'
import {
  NavDirection,
  NavTabBackground,
  NavTabIconSize,
  NavTabJustifyContent,
} from './NavTab.h'
import { NavTabLink, NavTabSC } from './NavTab.styled'

export interface INavTabProps {
  ref?: Ref<HTMLDivElement>
  title?: string
  selected?: boolean
  index?: number
  font?: TextBoxTypes
  icon?: IconNames
  iconSize?: NavTabIconSize
  paddings?: FIXED_INDENTS[]
  onClick?: (event?: React.MouseEvent<HTMLDivElement>) => void
  color?: ITextBoxProps['color']
  colorHovered?: ITextBoxProps['color']
  colorPressed?: ITextBoxProps['color']
  colorSelected?: ITextBoxProps['color']
  background?: NavTabBackground
  backgroundHovered?: NavTabBackground
  backgroundPressed?: NavTabBackground
  backgroundSelected?: NavTabBackground
  direction?: NavDirection
  width?: number
  iconPosition?: 'left' | 'right'
  justifyContentTab?: NavTabJustifyContent
}

NavTab.displayName = 'NavTab'
export function NavTab({
  ref,
  title = '',
  selected = false,
  font = TextBoxTypes.Body3,
  icon,
  iconSize = NavTabIconSize.Medium,
  direction = NavDirection.ROW,
  paddings = [FIXED_INDENTS.INDENT_40],
  width = 224,
  onClick,
  index,
  color,
  colorHovered = TextBoxColors.SURFACE_LIGHT_2,
  colorPressed = TextBoxColors.BASE_MAIN_PRESSED,
  colorSelected = TextBoxColors.TEXT_ICON_CONSTANT_LIGHT,
  background,
  backgroundHovered = NavTabBackground.COLOR_TRANSPARENT,
  backgroundPressed = NavTabBackground.COLOR_TRANSPARENT,
  backgroundSelected = NavTabBackground.COLOR_TRANSPARENT,
  iconPosition = 'left',
  justifyContentTab = NavTabJustifyContent.Start,
}: INavTabProps): JSX.Element {
  return (
    <NavTabSC
      backgroundSelected={backgroundSelected}
      background={background}
      selected={selected}
      colorSelected={colorSelected}
      icon={icon}
    >
      <NavTabLink
        iconPosition={iconPosition}
        justifyContentTab={justifyContentTab}
        index={index}
        ref={ref}
        onClick={onClick}
        selected={selected}
        paddings={paddings}
        width={width}
        colorDefault={color}
        colorHovered={colorHovered}
        colorPressed={colorPressed}
        colorSelected={colorSelected}
        background={background}
        backgroundHovered={backgroundHovered}
        backgroundPressed={backgroundPressed}
        backgroundSelected={backgroundSelected}
        font={font}
        icon={icon}
        direction={direction}
        className={selected ? 'active' : ''}
        title={title}
      >
        {icon && direction === NavDirection.COLUMN && (
          <Icon
            name={icon}
            filled={selected}
            size={iconSize ? IconSizes[iconSize] : null}
          />
        )}
        {title && <TextBox title={title} maxLines={1} />}
      </NavTabLink>
    </NavTabSC>
  )
}
